<template>
  <section class="workspace-placeholder" aria-labelledby="missing-title">
    <div class="workspace-badge" aria-hidden="true">404</div>
    <p class="eyebrow">AI 营销项目经理</p>
    <h1 id="missing-title">这个页面不存在</h1>
    <p>请返回云端入口继续。</p>
    <RouterLink to="/login">返回云端入口</RouterLink>
  </section>
</template>
